import { HorizontalScroll } from "@/components/shared/horizontal-scroll";
import type { Review } from "@/types/booking";
import { ReviewCard } from "@/components/shared/review-card";
import { useComponentWidth } from "@/components/hooks/use-component-width";
import { View } from "@/components/ui";
import { getPlatform } from "@/lib/utils";
import { useRef } from "react";
import { IconButton } from "@/components/ui/icon-button";
import type { HorizontalScrollRef } from "@/components/shared/horizontal-scroll/lib";

export const ServiceProfessionalScroll = ({
  reviews,
}: {
  reviews: Review[];
}) => {
  const { ref, width, onLayout } = useComponentWidth();
  const scrollRef = useRef<HorizontalScrollRef>(null);
  const isReviewsMoreThanOne = reviews.length > 1;
  const paddings = 16;
  const itemWidth =
    isReviewsMoreThanOne && getPlatform() !== "web"
      ? Math.floor(width * 0.9 - paddings * 2)
      : width - paddings * 2;
  return (
    <View ref={ref} onLayout={onLayout} className="w-full">
      <HorizontalScroll
        ref={scrollRef}
        data={reviews}
        snap="start"
        itemSpacing={16}
        itemWidth={itemWidth}
        contentPadding={{
          start: paddings,
          end: paddings,
        }}
        renderItem={(review, index) => {
          return (
            <ReviewCard
              {...review}
              key={index}
              contentClassName="md:p-4 m-0 h-[180px]"
              showImages={false}
            />
          );
        }}
      />
      {isReviewsMoreThanOne && (
        <View className="native:hidden mt-4 flex flex-row items-center justify-center gap-2">
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretLeft"
            onClick={() => scrollRef.current?.prev()}
            className="h-7 w-7 border border-input bg-background"
          />
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretRight"
            onClick={() => scrollRef.current?.next()}
            className="h-7 w-7 border border-input bg-background"
          />
        </View>
      )}
    </View>
  );
};
